<template>
  <div>
    <HomeLiveItem
      :at="item.created_at"
      @click="show = true"
    >
      <template #image>
        <img
          alt="cart-bubble"
          :src="cartBubble"
          class="w-full h-full"
        >
      </template>
      <p class="font-semibold">
        {{ name }}
      </p>
      <p>
        Commande click & Collect
      </p>
      <OrderPaidOnlineBadge
        v-if="isPaidOnline"
        class="mt-1"
      />
    </HomeLiveItem>
    <OrderActionModal
      v-if="show"
      :process-action="item"
      :order-id="item.id"
      :opened="show"
      @close-modal="close"
      @show="showCustomer"
    />
  </div>
</template>

<script lang="ts" setup>
import {computed, ref} from "vue";
import cartBubble from '@/assets/icons/cart-bubble.svg';
import {HomeOrderItem} from "@/home/interfaces";
import HomeLiveItem from "@/home/components/HomeLiveItem.vue";
import OrderActionModal from "@/order/components/OrderActionModal.vue";
import OrderPaidOnlineBadge from "@/order/components/OrderPaidOnlineBadge.vue";
import OrderService from "@/order/services/OrderService";
import {useRouter} from "vue-router";
import Customer from "@/customer/interfaces/Customer";
import {OrderIndex} from "@/order/interfaces/Order";

const router = useRouter();

const props = defineProps<{
    item: HomeOrderItem['data']
}>();
const show = ref(false);


const isPaidOnline = computed(() => OrderService.isPaidOnline(props.item as OrderIndex));

const name = computed(() => {
    if ("name" in props.item.customer) {
        return props.item.customer.name;
    }

    return `${props.item.customer.information?.first_name} ${props.item.customer.information?.last_name}`;
});

/**
 * Close the modal.
 */
const close = () => {
    show.value = false;
};

/**
 * Show the patient.
 *
 * @param customer
 */
const showCustomer = (customer: Customer) => {
    close();
    router.push({
        name: 'customer.home',
        params: {
            customerId: customer.id
        }
    });
};
</script>
